import { render } from "./UpsertFormComponent.vue?vue&type=template&id=2620f9f3&scoped=true"
import script from "./UpsertFormComponent.vue?vue&type=script&lang=js"
export * from "./UpsertFormComponent.vue?vue&type=script&lang=js"

import "./UpsertFormComponent.vue?vue&type=style&index=0&id=2620f9f3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2620f9f3"]])

export default __exports__